module.exports = __webpack_public_path__ + "img/Ulrikas_E-learning_info_om_kurs.4ee8b394.jpg";